import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .25,
		y: 1.25,
		width: 20.5,
		height: 15.5,
		rx: 2.75,
		stroke: "black",
		strokeWidth: .5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.708 10.324L11.124 11.308C10.404 12.412 9.144 13.12 7.644 13.12C5.292 13.12 3.492 11.212 3.492 8.884C3.492 6.544 5.292 4.636 7.644 4.636C9.132 4.636 10.368 5.332 11.088 6.388L9.66 7.372C9.216 6.712 8.508 6.292 7.644 6.292C6.264 6.292 5.256 7.444 5.256 8.884C5.256 10.312 6.264 11.464 7.644 11.464C8.508 11.464 9.264 10.996 9.708 10.324ZM11.8226 10.18C11.8226 8.404 13.2746 7.276 14.8706 7.276C15.8786 7.276 16.7666 7.696 17.3066 8.464L15.9506 9.436C15.7226 9.064 15.3026 8.872 14.8706 8.872C14.1626 8.872 13.4786 9.376 13.4786 10.18C13.4786 10.984 14.1626 11.524 14.8706 11.524C15.3026 11.524 15.7226 11.332 15.9506 10.96L17.3066 11.92C16.7786 12.688 15.8786 13.12 14.8706 13.12C13.2746 13.12 11.8226 11.944 11.8226 10.18Z",
		fill: "black"
	})]
});
export default SvgCc;
